<app-modal
  *ngIf='openModal'
  (onOkToParent)='okCloseButtonClick(true)'
  (onCloseToParent)='okCloseButtonClick(false)'
  [dialogTitle]="dialogTitle"
  [dialogTextLine1]="dialogTextLine1"
  [dialogTextLine2]="dialogTextLine2"
  [primaryButtonText]="'OK'"
  [secondaryButtonText]="cancelButton"
></app-modal>
